import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {PEV} from "../../../common/utils";
import * as service from "./service";
import {loadUserTabMetaData} from "./userTabLocalStorage";

export const allUsersTab = {id: "allUsers", name: "Users"};
export const allUsersTable = {id: "allUsersTable"};
export const fixedColumnsTitle = ["User"];

const initialState = {
  userList: PEV({
    data: [],
    totalPages: 0,
    totalElements: 0,
    canViewAllUsers: null,
  }),
};

const getUserList = createAsyncThunk("userList/fetch", async (param) => {
  return await service.fetchUserList(param.page, param.size, param.userQuery, param.sorter);
});

const UserListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    setActiveColumns(state, action) {
      let {selectedColumns} = action.payload;
      state.selectedColumns = selectedColumns;
    },
    resetUsersList(state) {
      state.userList = initialState.userList;
    },
  },
  extraReducers: {
    [getUserList.pending.type]: (state) => {
      state.userList = PEV({...initialState.userList.value}, "Fetching users");
    },
    [getUserList.fulfilled.type]: (state, action) => {
      state.userList = PEV({
        data: action.payload.dataSource,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
        canViewAllUsers: action.payload.canViewAllUsers,
      });
      state.selectedColumns = loadUserTabMetaData().selectedColumns
        ? loadUserTabMetaData().selectedColumns
        : action.payload.columns.map(({title}) => title);
      state.columns = state.columns ? state.columns : action.payload.columns;
    },
    [getUserList.rejected.type]: (state) => {
      state.userList = PEV({...initialState.userList.value}, null, "Error while fetching users");
    },
  },
});

export const UserListReducer = UserListSlice.reducer;
const {setActiveColumns, resetUsersList} = UserListSlice.actions;
export const UserListActions = {setActiveColumns, getUserList, resetUsersList};
export const getSelectedUserColumns = (state) => state?.selectedColumns ?? [];
export const getTotalColumns = (state) => state?.columns?.map(({title}) => title) ?? [];
